import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  ETimeBucketType,
  IReportingCampaignsChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDACampaignsReportChartFilters,
  TDOOHCampaignsReportChartFilters,
  TGenericCampaignsReportChartFilters,
  TPPAdvertiserId,
  TSPCampaignsReportChartFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingCampaignsChartV3({
  advertiserId,
  retailerId,
  channelType,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (
  | TGenericCampaignsReportChartFilters
  | TSPCampaignsReportChartFilters
  | TDACampaignsReportChartFilters
  | TDOOHCampaignsReportChartFilters
) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingCampaignsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingCampaignsChart_${channelType}_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3
        .advertiserReporting()
        .getAdvertiserCampaignsReportChartV3(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          channelType as EParamChannelTypeGlobal,
          timeWindow as unknown as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          aggregationType as ETimeBucketType,
          filterBy,
          filterOperation,
          filterValue,
          name,
          // @ts-expect-error: fix in PORT-2535
          status
        )
    },
    { suspense, enabled }
  )
}
